export default __webpack_public_path__ + "static/media/channelworm.67cb6d89.gif";